import { ModalProps } from "shared/types/modal";
import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import CustomButton from "shared/components/common/customButton";

interface Props extends ModalProps {
  title?: string;
  subtitle?: string;
  handleSubmit?: () => void;
  actionButtonText?: string;
  cancelButtonText?: string;
  loading?: boolean;
  modalType?: "success" | "confirmation" | "error" | "delete";
}

const ConfirmationModal = ({
  title,
  subtitle,
  actionButtonText,
  cancelButtonText,
  loading,
  show,
  handleClose,
  handleSubmit,
  modalType = "delete",
}: Props) => {
  if (!show) return null;

  return (
    <CustomModal
      isOpen={show}
      size="sm"
      onClose={handleClose}
      customContentContainer={styles.customContentContainer}
    >
      <div className={classNames(styles.contentContainer)}>
        <div className="flex items-center justify-end px-4 mt-4 mb-3"></div>

        <div
          className={classNames(
            styles.modalBody,
            "w-full flex items-center justify-center flex-col gap-4",
          )}
        >
          {modalType === "success" && (
            <span
              className={classNames(
                styles.iconContainer,
                styles.iconContainerSuccess,
              )}
            >
              <Icons.SuccessModalIcon className={styles.successIcon} />
            </span>
          )}
          {modalType === "confirmation" && (
            <span
              className={classNames(
                styles.iconContainer,
                styles.iconContainerConfirmation,
              )}
            >
              <Icons.WarningIcon className={styles.confirmationIcon} />
            </span>
          )}
          {modalType === "error" && (
            <span
              className={classNames(
                styles.iconContainer,
                styles.iconContainerError,
              )}
            >
              <Icons.Reject className={styles.errorIcon} />
            </span>
          )}
          {modalType === "delete" && (
            <span
              className={classNames(
                styles.iconContainer,
                styles.iconContainerDelete,
              )}
            >
              <Icons.Trash className={styles.deleteIcon} />
            </span>
          )}
          <div
            className={classNames("flex flex-col gap-2 mb-4", styles.textBlock)}
          >
            <h6>{title || "Are you sure?"}</h6>
            <p>{subtitle || "Are you sure you want to proceed?"}</p>
          </div>

          <div
            className={classNames(
              styles.buttonContainer,
              "flex items-center w-full gap-4",
              cancelButtonText && actionButtonText
                ? "justify-between"
                : "justify-center",
            )}
          >
            {cancelButtonText && (
              <CustomButton
                title={cancelButtonText || "Got it!"}
                onClick={handleClose}
                containerStyle={classNames(
                  "primary-outline-btn",
                  cancelButtonText && actionButtonText ? "w-full" : "",
                )}
              />
            )}
            {actionButtonText && (
              <CustomButton
                title={actionButtonText || "Yes, Confirm"}
                onClick={handleSubmit}
                loading={loading}
                disabled={loading}
                containerStyle={classNames(
                  "primary-outline-btn",
                  styles.actionButton,
                  cancelButtonText && actionButtonText ? "w-full" : "",
                )}
              />
            )}
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
